/* Gadget Bazaar — product-form.js
   Variant selection on the product page: updates selected variant id, price, availability, URL. */
(function () {
  'use strict';

  function money(cents) {
    var n = Math.round((cents || 0) / 100);
    try { return '₨ ' + new Intl.NumberFormat('en-PK').format(n); }
    catch (e) { return '₨ ' + n; }
  }

  function initForm(root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-pdp-price]');
    var compareEl = document.querySelector('[data-pdp-compare]');
    var submit = root.querySelector('[type="submit"]');
    var optionInputs = root.querySelectorAll('[data-option-index]');

    function selectedOptions() {
      var opts = [];
      optionInputs.forEach(function (el) {
        if (el.type === 'radio') { if (el.checked) opts[+el.dataset.optionIndex] = el.value; }
        else { opts[+el.dataset.optionIndex] = el.value; }
      });
      return opts;
    }

    function match() {
      var opts = selectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function update() {
      var v = match();
      if (!v) { if (submit) { submit.setAttribute('disabled', 'true'); submit.textContent = 'Unavailable'; } return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price); compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (submit) {
        if (v.available) { submit.removeAttribute('disabled'); submit.textContent = submit.dataset.label || 'Add to Cart'; }
        else { submit.setAttribute('disabled', 'true'); submit.textContent = 'Sold Out'; }
      }
      // swatch active state
      optionInputs.forEach(function (el) {
        if (el.type === 'radio') {
          var label = el.closest('label');
          if (label) label.classList.toggle('is-active', el.checked);
        }
      });
      if (history.replaceState && v.id) {
        var url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
    }

    root.addEventListener('change', function (e) { if (e.target.matches('[data-option-index]')) update(); });
    update();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-form]').forEach(initForm);
  });
})();
